/**
 * Centralized Query Keys
 * All query keys in one place for consistency and easy invalidation
 */

export const queryKeys = {
    // ============================================
    // USER & AUTHENTICATION
    // ============================================
    user: ['user'],
    authSession: ['authSession'],

    // ============================================
    // CREDITS & BILLING
    // ============================================
    credits: ['credits'],
    creditHistory: (options = {}) => ['creditHistory', options],
    creditAnalytics: (options = {}) => ['creditAnalytics', options],

    // Billing
    pricing: ['pricing'],
    invoices: (options = {}) => ['invoices', options],
    planLimits: ['planLimits'],

    // ============================================
    // SESSIONS (Workflow Sessions)
    // ============================================
    workflowSession: (sessionId) => ['workflowSession', sessionId],
    userSessions: (options = {}) => ['userSessions', options],
    activeSession: ['activeSession'],

    // ============================================
    // REFERRALS
    // ============================================
    referralCode: ['referralCode'],
    referralStats: ['referralStats'],
    referralHistory: (limit = 10) => ['referralHistory', limit],
    referralData: ['referralData'],

    // ============================================
    // WORKFLOW STATUS (Polling)
    // ============================================
    researchStatus: (taskId, agentId) => ['researchStatus', taskId, agentId],
    validationStatus: (taskId, agentId) => ['validationStatus', taskId, agentId],
    analysisStatus: (taskId, agentId) => ['analysisStatus', taskId, agentId],
    promptStatus: (taskId, agentId) => ['promptStatus', taskId, agentId],

    // ============================================
    // PLANS
    // ============================================
    availablePlans: ['availablePlans'],

    // ============================================
    // SECURITY (Session/Device Management)
    // ============================================
    securitySessions: ['securitySessions'],
    securityDevices: ['securityDevices'],
};

export default queryKeys;
